import React, { useState, useEffect, useRef } from 'react';
import vasoEstatico from '../assets/nuestra-esencia/VasoPromo_NuestraEsencia.png';
import vasoMovible from '../assets/nuestra-esencia/Vaso_Mega.gif';
import vasoVerde from '../assets/nuestra-esencia/vasoVerde.png';
import esenciaMega from '../assets/nuestra-esencia/esencia_mega.png'
const NuestraEsencia = () => {
  const [fade, setFade] = useState(false);
  const vasoRef = useRef(null);
  const destinoRef = useRef(null);

  useEffect(() => {
    // Después de 4.5 segundos inicia la transición
    const timer = setTimeout(() => {
      setFade(true); // activa el fade hacia vasoEstatico
    }, 4500);

    return () => clearTimeout(timer);
  }, []);
  
  //Efecto Scroll
  useEffect(() => {
    const handleScroll = () => {
      if (!vasoRef.current || !destinoRef.current) return;

      const vaso = vasoRef.current;
      const destino = destinoRef.current.getBoundingClientRect();
      
      // Si el scroll todavía no ha llegado al destino, mueve el vaso
      if (window.scrollY + window.innerHeight / 2 < window.scrollY + destino.top) {
        vaso.style.transform = `translateY(${window.scrollY * 0.7}px)`; // velocidad del scroll
      }else {
        vaso.style.position = "sticky";
        vaso.style.top = `${destino.top + window.scrollY}px`;
        vaso.style.zIndex = 1; 
        vaso.style.left = `${destino.left}px`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="main-content">
      <div className="container-fluid p-0">
        <div className="page-container pt-0 pb-0">
          {/* Text */}
          <div className='container-fluid pdg-section-ch'>
            <div className="row align-items-center mb-md-5">
              <div className="col-12 text-start p-0">
                <h1 className="display-4  lightblack mb-3 tit-principal" style={{width:'75%'}}>
                    <span style={{ color: 'var(--color-principal)'}}>En Mega Label nos apasiona transformar simples etiquetas en algo más...</span>
                </h1>
              </div>
            </div>
          </div>
          {/*Contenedor de Vaso Azul*/}
          <div className='container-fluid pdg-section pt-md-5 conteiner-vasoverde' style={{paddingBottom: '22%'}}>
            <div className="row mb-5">
              <div className="col-md-6 d-flex flex-column">
                <p className="lightblack" style={{width:'60%', marginTop:'15%', marginLeft:'16.5%', fontWeight:'900', fontSize:'2.7rem', letterSpacing: '0px', lineHeight: '46px'}}>
                  Tanto, que las convertimos en vasos.
                </p>                
              </div>
              <div className="col-md-6">
                <div className="flex justify-center items-center h-screen relative">
                  {/* Imagen vasoMovible */}
                  <img
                    src={vasoMovible}
                    alt="Vaso en movimiento"
                    className={`rounded vaso-azul rounded-2xl absolute transition-opacity duration-1000 ${
                      fade ? "opacity-0 d-none" : "opacity-100 d-block"
                    }`}
                  />
                  {/* Imagen vasoEstatico */}
                  {/**Función para que el vaso haga scroll */}
                  <img
                    ref={vasoRef}
                    src={vasoEstatico}
                    alt="Vaso estático"
                    className={`rounded vaso-azul rounded-2xl absolute transition-opacity duration-1000 ${
                      fade ? "opacity-100" : "opacity-0"
                    }`}
                  />
                  {/*<img
                    src={vasoEstatico}
                    alt="Vaso estático"
                    className={`rounded vaso-azul rounded-2xl absolute transition-opacity duration-1000 ${
                      fade ? "opacity-100" : "opacity-0"
                    }`}
                  />*/}
                </div>
              </div>
            </div>
          </div>
          {/* Nuestro Manifiesto Section 3 */}
          <div className='container-fluid pdg-section ' style={{background:'black'}}  >
            <div className="row align-items-end mb-md-5">
              <div className="col-md-6 col-12 order-md-0 order-1" style={{padding:'0% 0.7%', margin:'0%'}}>
                <div className='gray-background pt-5 nuest-cons' >
                  <h2 className="display-5 fw-bold tit-principal" style={{ color: 'var(--color-principal)'}} >
                    Nuestro Manifiesto
                  </h2>
                  <p className="lightblack mb-4" style={{color:'white'}}>
                    Con más de <strong>28 años en el mercado,</strong> en <strong>Mega Label</strong> somos especialistas en soluciones de empaque y personalización que elevan el valor de tu marca.
                  </p>
                  <p className="lightblack mb-4" style={{color:'white'}}>
                    Hemos acompañado a múltiples industrias en retos únicos, desde etiquetas para botellas que viajan por todo el mundo, frascos diminutos que requieren precisión absoluta y empaques que resisten diferentes cambios de temperatura. Cada desafío nos ha impulsado a innovar y perfeccionar nuestras soluciones.
                  </p>
                  <p className="lightblack mb-4" style={{color:'white'}}>
                   Nuestros diseños y procesos están pensados para que tus productos destaquen desde el primer instante, ofreciendo <strong>etiquetas autoadheribles, mangas termoencogibles, vasos promocionales y termoformado</strong>, respaldados por tecnología de vanguardia y un equipo experto que garantiza calidad, innovación y tiempos de entrega competitivos.
                  </p>
                  <p className="lightblack mb-4" style={{color:'white'}}>
                    Contamos con tecnología de vanguardia en Latinoamérica, lo que nos permite ofrecer <strong>mejores tiempos de entrega, amplia personalización y acabados de alto impacto.</strong> Nuestros materiales y técnicas aseguran que cada etiqueta permanezca intacta sin importar la condición, manteniendo siempre la imagen de tu marca en perfecto estado.
                  </p>
                  <p className="lightblack mb-4" style={{color:'white'}}>
                    En Mega Label creemos que una etiqueta no es solo un accesorio: es el <strong>primer contacto con tu cliente,</strong> el detalle que transmite confianza por lo que no solo imprimimos etiquetas, <strong>creamos etiquetas que venden, protegen y elevan tu marca.</strong>
                  </p>
                  <p className="lightblack mb-4" style={{color:'white'}}>
                    Nuestra experiencia está respaldada por procesos estandarizados y certificados, que garantizan <strong>seguridad, calidad y confianza</strong> en cada proyecto. Además, hemos formado un equipo de especialistas con amplia trayectoria en la industria, comprometidos en brindar las etiquetas perfectas para cada producto.
                  </p>
                  <p className="lightblack mb-4" style={{color:'white'}}>
                    Sabemos que cada corte, cada tinta y cada material, se convierten en etiquetas que elevan tu marca, brindan seguridad y fortalecen tu presencia en el mercado.
                  </p>
                  <p className="lightblack mb-4" style={{color:'white'}}>      
                    <strong>
                      En Mega Label, somos etiquetas que hacen más.
                    </strong>
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-12 order-md-1 order-0" >
                <div>
                {/**Función para que el vaso haga scroll */}
                <div style={{display:'block'}} ref={destinoRef}></div>
                <img 
                  src={vasoVerde}
                  alt="Maquinaria de Etiquetado"
                  className="vaso-verde"
                  style={{
                    position:'relative',
                    //width:'58%',
                    top:0,
                    left: '37%',
                    zIndex:5
                  }}
                />
                </div>
                <div className='container-fluid p-0'>
                  <img 
                    src={esenciaMega}
                    alt="Oficinas MegaLabel"
                    className="office-megalabel"
                    />
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NuestraEsencia; 